import { Calendar as CalendarIcon } from 'iconoir-react'
import { useMemo } from 'react'
import Combo from 'app/components/ui/combo/combo'
import type { ScorecardJson } from 'app/types/entities'

const SelectorPresetOptions = [
  { value: `today`, name: `Today`, id: `today` },
  { value: `this_week`, name: `This week`, id: `this_week` },
  { value: `last_week`, name: `Last week`, id: `last_week` },
  { value: `this_month`, name: `This month`, id: `this_month` },
  { value: `last_month`, name: `Last month`, id: `last_month` },
  { value: `this_quarter`, name: `This quarter`, id: `this_quarter` },
  { value: `this_year`, name: `This year`, id: `this_year` },
  { value: `last_year`, name: `Last year`, id: `last_year` },
  { value: `last_30_days`, name: `Last 30 days`, id: `last_30_days` },
  { value: `last_90_days`, name: `Last 90 days`, id: `last_90_days` },
  { value: `last_6_months`, name: `Last 6 months`, id: `last_6_months` },
  { value: `last_12_months`, name: `Last 12 months`, id: `last_12_months` },
]

export default function DateRangeSelector({
  currentValue,
  inputClassName,
  onChange,
}: {
  currentValue: ScorecardJson[`dateRange`]
  inputClassName?: string
  onChange: (value: NonNullable<ScorecardJson[`dateRange`]>) => void
}) {
  const value = useMemo(() => SelectorPresetOptions.find((option) => option.value === currentValue), [currentValue])
  return (
    <Combo
      showSearchInDropdown={false}
      options={SelectorPresetOptions}
      value={value}
      onChange={(option) => onChange(option.value)}
      customIcon={<CalendarIcon className="h-5 w-5 text-default" />}
      className="!h-fit w-40 cursor-pointer"
      optionsContainerClassName="min-w-0 w-64"
      inputClassName={inputClassName}
    />
  )
}
